import axios from '../api/axios';

export async function getCarHouses(pagination, options) {

  const headers = {
    page: pagination.page,
    limit: pagination.total,
  };

  options['headers'] = headers;

  const res = await axios.get('/carHouses', options);

  const data = {
    carHouses: res.data.results,
    count: res.data.count,
  };

  return data;
}

export async function getCarHouseById(carHouseId) {

  const res = await axios.get(`/carHouses/${carHouseId}`)
  return res;
}

export async function createCarHouse(body) {
  const response = await axios.post('/carHouses', JSON.stringify(body), {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
}

export async function updateCarHouse(carHouseId, body) {
  const response = await axios.patch(
    `/carHouses/${carHouseId}`,
    JSON.stringify(body),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
}

export async function deleteCarHouse(carHouseId) {
  const response = await axios.delete(`/carHouses/${carHouseId}`);
  return response;
}

export async function addCarHouseCredit(carHouseId, body) {
  const response = await axios.post(
    `/carHouses/${carHouseId}/credits`,
    JSON.stringify(body),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
}

export async function getCarHouseCreditsHistory(carHouseId) {
  const response = await axios.get(`/carHouses/${carHouseId}/credits-history`);

  return response.data;
}